'use strict';

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.options = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _logo = require('./logo.png');

var _logo2 = _interopRequireDefault(_logo);

var _hearts_animation = require('./hearts_animation.svg');

var _hearts_animation2 = _interopRequireDefault(_hearts_animation);

var _tinycolor = require('tinycolor2');

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var options = exports.options = {};

var factory = function factory(_ref) {
  var identifier = _ref.identifier;

  var Footer = function (_React$Component) {
    _inherits(Footer, _React$Component);

    function Footer() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, Footer);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Footer.__proto__ || Object.getPrototypeOf(Footer)).call.apply(_ref2, [this].concat(args))), _this), _this.renderLink = function (theme, link, text) {
        return _react2['default'].createElement('a', {
          className: theme.link,
          href: link,
          target: '_blank',
          rel: 'noopener noreferrer'
        }, text);
      }, _this.renderClaim = function () {
        var _this$props = _this.props,
            theme = _this$props.theme,
            claimText = _this$props.claimText,
            animated = _this$props.animated,
            utmParams = _this$props.utmParams;
        return _react2['default'].createElement('a', {
          href: 'https://perspective.co/' + utmParams,
          target: '_blank',
          rel: 'noopener noreferrer',
          className: (0, _classnames2['default'])(theme.claimButton, _defineProperty({}, theme.dark, _this.isOnLightBg))
        }, animated && _react2['default'].createElement('img', {
          src: _hearts_animation2['default'],
          alt: 'animated hearts',
          className: theme.hearts
        }), _react2['default'].createElement('img', {
          src: _logo2['default'],
          alt: 'logo',
          className: theme.claimLogo
        }), _react2['default'].createElement('span', {
          className: (0, _classnames2['default'])(theme.claimText, _defineProperty({}, theme.dark, _this.isOnLightBg))
        }, claimText));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Footer, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            legalLink = _props.legalLink,
            termsLink = _props.termsLink,
            theme = _props.theme;
        return _react2['default'].createElement('div', {
          className: this.wrapperClass
        }, _react2['default'].createElement('div', {
          className: theme.innerContent
        }, this.brandingElement, (legalLink || termsLink) && _react2['default'].createElement('div', {
          className: this.linksClass
        }, this.legalLinkElement, ' ', this.connectionElement, ' ', this.termsLinkElement)));
      }
    }, {
      key: 'isOnLightBg',
      get: function get() {
        var color = (0, _tinycolor2['default'])(this.props.bgColorReference);
        return color.isLight();
      }
    }, {
      key: 'linksClass',
      get: function get() {
        var _cn3;

        var _props2 = this.props,
            theme = _props2.theme,
            branding = _props2.branding;
        return (0, _classnames2['default'])(theme.links, (_cn3 = {}, _defineProperty(_cn3, theme.spaced, branding), _defineProperty(_cn3, theme.dark, this.isOnLightBg), _cn3));
      }
    }, {
      key: 'wrapperClass',
      get: function get() {
        var _cn4;

        var _props3 = this.props,
            theme = _props3.theme,
            className = _props3.className,
            termsLink = _props3.termsLink,
            legalLink = _props3.legalLink,
            branding = _props3.branding,
            noInteraction = _props3.noInteraction;
        return (0, _classnames2['default'])(theme.footerWrapper, (_cn4 = {}, _defineProperty(_cn4, theme.empty, !termsLink && !legalLink && !branding), _defineProperty(_cn4, theme.noInteraction, noInteraction), _cn4), className);
      }
    }, {
      key: 'brandingElement',
      get: function get() {
        var branding = this.props.branding;
        return branding ? this.renderClaim() : null;
      }
    }, {
      key: 'legalLinkElement',
      get: function get() {
        var _props4 = this.props,
            legalLink = _props4.legalLink,
            legalText = _props4.legalText,
            theme = _props4.theme;
        return legalLink && legalText ? this.renderLink(theme, legalLink, legalText) : null;
      }
    }, {
      key: 'termsLinkElement',
      get: function get() {
        var _props5 = this.props,
            termsLink = _props5.termsLink,
            termsText = _props5.termsText,
            theme = _props5.theme;
        return termsLink && termsText ? this.renderLink(theme, termsLink, termsText) : null;
      }
    }, {
      key: 'connectionElement',
      get: function get() {
        var _props6 = this.props,
            termsLink = _props6.termsLink,
            legalLink = _props6.legalLink,
            theme = _props6.theme;
        return termsLink && legalLink ? _react2['default'].createElement('span', {
          className: theme.connector
        }, '\xB7') : null;
      }
    }]);

    return Footer;
  }(_react2['default'].Component);

  Footer.displayName = identifier;
  Footer.propTypes = {
    legalLink: _propTypes2['default'].string,
    legalText: _propTypes2['default'].string,
    termsLink: _propTypes2['default'].string,
    termsText: _propTypes2['default'].string,
    claimText: _propTypes2['default'].string,
    bgColorReference: _propTypes2['default'].string,
    branding: _propTypes2['default'].bool,
    animated: _propTypes2['default'].bool,
    noInteraction: _propTypes2['default'].bool,
    theme: _propTypes2['default'].shape({
      footerWrapper: _propTypes2['default'].string,
      links: _propTypes2['default'].string,
      spaced: _propTypes2['default'].string,
      link: _propTypes2['default'].string
    }),
    className: _propTypes2['default'].string,
    utmParams: _propTypes2['default'].string
  };
  Footer.defaultProps = {
    branding: true,
    animated: true,
    noInteraction: false,
    legalText: 'Imprint',
    termsText: 'Privacy',
    claimText: 'We use Perspective',
    bgColorReference: '#FFFFFF',
    utmParams: ''
  };
  return Footer;
};

exports['default'] = factory;